module.exports = __webpack_public_path__ + "img/zeus_full_invert.3efc4f32.svg";